/**
 * author: Patrick Vyn Badiang
 *
 * description:
 * After declaring the header text, it calls ResourcesTemplate
 * and passes an array of elements it wants to be displayed below it.
 */


import { Box, Typography } from "@mui/material";

import ResourcesTemplate from "./ResourcesTemplate";
import HealthData from "./HealthData.json";
import AdvocacyData from "./AdvocacyData.json";
import LanguageData from "./LanguageData.json";
import PageHero from "../../../utils/PageHero";
import resourcesHero from "../../../pictures/Hero/ResourcesHero.svg";
import { mustard } from "../../../styles.tsx";


function ResourcesPage() {

    return (
        <>
            <PageHero
                image={resourcesHero}
                viewBoxWidth={999}
                viewBoxHeight={500}
                cropHeight={360}
                bandColor="#AD5D4E"
                accessibleTitle="Community Resources"
            />

            <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
                <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
                    <Typography variant="h2" sx={{ color: mustard, mb: "40px" }}>
                        Mental Health
                    </Typography>
                    <ResourcesTemplate images={HealthData} cardColor="background.default" descColor="#4a4a4a" />
                </Box>
            </Box>

            <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
                <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
                    <Typography variant="h2" sx={{ mb: "40px" }}>
                        Other Advocacies
                    </Typography>
                    <ResourcesTemplate images={AdvocacyData} cardColor="background.paper" descColor="#2b2b2b" shadowColors={["#12201f", "#ad5d4e"]} />
                </Box>
            </Box>

            <Box sx={{ bgcolor: mustard, px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
                <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
                    <Typography variant="h2" sx={{ color: "primary.main", mb: "40px" }}>
                        Learn Tagalog!
                    </Typography>
                    <ResourcesTemplate images={LanguageData} cardColor="background.default" descColor="#4a4a4a" shadowColors={["#ad5d4e", "#12201f"]} />
                </Box>
            </Box>
        </>
    );
}

export default ResourcesPage;
